// Debug utility for controlled logging
const DEBUG = process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG == 'true';

// Helper to get caller location
const getCallerLocation = () => {
  const stack = new Error().stack;
  const lines = stack.split('\n');
  
  // Skip the first line (Error) and look for the first line that's not from debug.js
  for (let i = 2; i < lines.length; i++) {
    const line = lines[i];
    
    // Skip lines from debug.js, bundle.js, and any webpack-related files
    if (line.includes('debug.js') || 
        line.includes('bundle.js') || 
        line.includes('webpack') ||
        line.includes('node_modules')) {
      continue;
    }
    
    // Try to extract the source file path
    const match = line.match(/at\s+(.+?)\s+\((.+?):(\d+):(\d+)\)/);
    if (match) {
      const [, functionName, file, line, column] = match;
      
      // Try to extract the original source file path
      const sourceMatch = file.match(/\/([^/]+)\.(js|jsx|ts|tsx)$/);
      if (sourceMatch) {
        return `${sourceMatch[1]}:${line}`;
      }
      
      // Fallback to just the filename
      const fileName = file.split('/').pop();
      return `${fileName}:${line}`;
    }
  }
  return 'unknown location';
};

// Helper to format the log message
const formatLogMessage = (location, args) => {
  // If the first argument is a string, use it as a format string
  if (typeof args[0] === 'string') {
    const format = args[0];
    const values = args.slice(1);
    return [`[${location}] ${format}`, ...values];
  }
  // Otherwise, just prepend the location
  return [`[${location}]`, ...args];
};

export const debug = {
  log: (...args) => {
    if (DEBUG) {
      const location = getCallerLocation();
      console.log(...formatLogMessage(location, args));
    }
  },
  
  error: (...args) => {
    // Always log errors, but in production we might want to send them to a logging service
    const location = getCallerLocation();
    console.error(...formatLogMessage(location, args));
  },
  
  warn: (...args) => {
    if (DEBUG) {
      const location = getCallerLocation();
      console.warn(...formatLogMessage(location, args));
    }
  },
  
  info: (...args) => {
    if (DEBUG) {
      const location = getCallerLocation();
      console.info(...formatLogMessage(location, args));
    }
  }
}; 